module.exports = "/_next/static/images/rosegold-118e51bec8d7aacf06e08086f1c08fd0.png";